import { create } from "zustand";

export interface LayoutState {
  collapsed: boolean;
  toggleCollapsed: (value: boolean) => void;
}

export const useLayoutStore = create<LayoutState>((set) => ({
  collapsed: true,
  toggleCollapsed: (value) => set({ collapsed: value }),
}));
